var swiper = new Swiper("#hero-home", {
    slidesPerView: 1,
    loop: true,
    effect: "fade",
    pagination: {
        el: ".home-slider-pagination",
        clickable: true,
    },
});

document.addEventListener("DOMContentLoaded", function() {
    let homeSlider = document.querySelectorAll(".shortcode-slider-home");
    var playButtons = document.querySelectorAll('.play-button');

    if(homeSlider.length > 0){
        homeSlider.forEach(function(slider) {
            var ellipse = document.createElement('div');
            ellipse.className = 'ellipse';
            slider.appendChild(ellipse);

            var observer = new IntersectionObserver(function(entries) {
                if(entries[0].isIntersecting === true)
                ellipse.style.animationPlayState = 'running';
            }, { rootMargin: '-100px 0px', threshold: [0] });

            observer.observe(slider);
        })
    


    function attachPlayEvent(button) {
        button.addEventListener('click', function(event) {
            event.preventDefault();
    
            var videoUrl = button.getAttribute('data-video');
            var slideElement = button.closest('.swiper-slide');
    
            // Sauvegarder le contenu original du slide
            var originalContent = [];
            slideElement?.childNodes.forEach(function(node) {
                originalContent.push(node.cloneNode(true));
            });
    
            var videoElement = document.createElement('video');
            videoElement.setAttribute('src', videoUrl);
            videoElement.setAttribute('controls', 'true');
            videoElement.setAttribute('autoplay', 'true');
    
            // Lorsque la vidéo est terminée, remettez le contenu original
            videoElement.addEventListener('ended', function() {
                // Vider le slide
                while(slideElement?.firstChild) {
                    slideElement.removeChild(slideElement.firstChild);
                }
    
                // Restaurer le contenu original
                originalContent.forEach(function(node) {
                    slideElement.appendChild(node);
                });
    
                // Ré-attacher les écouteurs d'événements aux boutons play
                slideElement.querySelectorAll('[data-video]').forEach(attachPlayEvent); // J'utilise [data-video] comme sélecteur, en supposant que tous vos boutons play ont cet attribut. Modifiez-le si ce n'est pas le cas.
            });
    
            // Vider le contenu actuel du slide
            while(slideElement?.firstChild) {
                slideElement.removeChild(slideElement.firstChild);
            }
    
            // Ajouter la vidéo
            slideElement?.appendChild(videoElement);
    
            videoElement.play();
        });
    }
    
    var playButtons = document.querySelectorAll('[data-video]'); // J'utilise [data-video] comme sélecteur, en supposant que tous vos boutons play ont cet attribut. Modifiez-le si ce n'est pas le cas.
    playButtons?.forEach(attachPlayEvent);

}
    
    
});
